export function mapValueToDashOffset(value: number) {
  return ((100 - value / 2) / 100) * -450
}
